import { ReactComponent as FlagIcon } from "./svg/uz-flag.svg";
import "../flag-icon.scss";

export const UZFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
